var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Illustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 200,
    viewBox: "0 0 475 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 475,
    height: 200,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3743.5 -648C-3743.5 -683.346 -3714.85 -712 -3679.5 -712H7238.5C7273.85 -712 7302.5 -683.346 7302.5 -648V2574C7302.5 2609.35 7273.85 2638 7238.5 2638H-3679.5C-3714.85 2638 -3743.5 2609.35 -3743.5 2574V-648Z",
    fill: "#DFFBE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3679.5 -712V-700H7238.5V-712V-724H-3679.5V-712ZM7302.5 -648H7290.5V2574H7302.5H7314.5V-648H7302.5ZM7238.5 2638V2626H-3679.5V2638V2650H7238.5V2638ZM-3743.5 2574H-3731.5V-648H-3743.5H-3755.5V2574H-3743.5ZM-3679.5 2638V2626C-3708.22 2626 -3731.5 2602.72 -3731.5 2574H-3743.5H-3755.5C-3755.5 2615.97 -3721.47 2650 -3679.5 2650V2638ZM7302.5 2574H7290.5C7290.5 2602.72 7267.22 2626 7238.5 2626V2638V2650C7280.47 2650 7314.5 2615.97 7314.5 2574H7302.5ZM7238.5 -712V-700C7267.22 -700 7290.5 -676.719 7290.5 -648H7302.5H7314.5C7314.5 -689.974 7280.47 -724 7238.5 -724V-712ZM-3679.5 -712V-724C-3721.47 -724 -3755.5 -689.974 -3755.5 -648H-3743.5H-3731.5C-3731.5 -676.719 -3708.22 -700 -3679.5 -700V-712Z",
    fill: "#19A04B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4630_50580)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4630_50580)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 702,
    transform: "translate(-445.5 -164)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.486 157.923C30.2419 169.298 -5.89058 162.659 0.824841 195.675L475 195.675C475 191.253 439.377 141.268 395.928 141.268C369.651 141.268 353.594 170.27 313.126 132.799C299.882 120.537 291.393 120.827 277.154 120.059C257.034 118.974 235.936 133.273 230.69 135.796C200.782 150.183 214.203 128.982 167.739 135.796C153.018 137.955 138.499 161.198 107.364 147.899C76.2293 134.601 68.1884 134.045 42.486 157.923Z",
    fill: "#C2C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M458.023 76.3426H374.885C372.638 74.0918 374.884 68.4624 380.502 68.4614C386.12 68.4603 383.366 62.6498 390.613 57.2033C399.601 50.4477 410.836 57.2034 414.207 61.707C417.577 66.2105 422.689 58.5056 429.935 60.5812C436.676 62.512 436.286 69.9688 440.047 68.4614C451.281 63.9588 459.147 76.3436 458.023 76.3426Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.177 90.5762H409.525C411.426 88.7226 409.525 84.0866 404.771 84.0858C400.018 84.0849 402.348 79.2998 396.216 74.8145C388.611 69.251 379.104 74.8146 376.252 78.5234C373.4 82.2322 369.075 75.8869 362.944 77.5962C357.24 79.1864 357.569 85.3272 354.387 84.0858C344.881 80.3778 338.226 90.577 339.177 90.5762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M151.554 19.4092H221.902C223.803 17.4233 221.903 12.4561 217.149 12.4552C212.396 12.4543 214.725 7.32734 208.594 2.52165C200.989 -3.43917 191.481 2.52174 188.629 6.49545C185.778 10.4692 181.453 3.67072 175.321 5.50211C169.617 7.20581 169.947 13.7853 166.765 12.4552C157.259 8.4824 150.603 19.4101 151.554 19.4092Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M0.124779 25.8792H97.3331C99.9601 23.2313 97.334 16.6084 90.765 16.6072C84.1969 16.606 87.4159 9.77003 78.9434 3.36244C68.4344 -4.58531 55.2971 3.36256 51.3562 8.66085C47.4153 13.9591 41.439 4.89454 32.9665 7.33639C25.0847 9.608 25.5405 18.3806 21.1428 16.6072C8.00761 11.3101 -1.18884 25.8804 0.124779 25.8792Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.406 92.5649C175.372 92.5651 176.156 93.3486 176.156 94.3149V155.787C176.156 155.925 176.268 156.037 176.406 156.037H186.582C187.549 156.037 188.332 156.82 188.332 157.787V172.326C188.332 173.292 187.549 174.075 186.582 174.076H176.406C176.268 174.076 176.156 174.188 176.156 174.326V193.248C176.155 194.214 175.372 194.997 174.406 194.998H155.591C154.625 194.997 153.841 194.214 153.841 193.248V174.326C153.841 174.188 153.729 174.076 153.591 174.076H112.407C111.44 174.076 110.657 173.292 110.657 172.326V158.791C110.657 158.44 110.762 158.096 110.959 157.806L154.806 93.3306C155.132 92.8515 155.674 92.565 156.253 92.5649H174.406ZM154.464 120.377C153.912 121.479 153.325 122.565 152.706 123.633L152.341 124.315C151.474 125.911 150.498 127.541 149.414 129.206L149.411 129.211L131.892 155.648C131.782 155.814 131.901 156.036 132.1 156.037H153.591C153.729 156.037 153.841 155.925 153.841 155.787V139.682C153.841 137.505 153.889 134.857 153.984 131.743C154.078 128.632 154.172 125.756 154.267 123.116V123.103L154.268 123.09C154.34 122.052 154.406 121.147 154.464 120.377Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.621 88.7561C333.587 88.7561 334.371 89.5396 334.371 90.5061V151.978C334.371 152.116 334.483 152.228 334.621 152.228H344.646C345.613 152.228 346.396 153.011 346.396 153.978V168.517C346.396 169.483 345.613 170.267 344.646 170.267H334.621C334.483 170.267 334.371 170.379 334.371 170.517V189.439C334.371 190.405 333.587 191.189 332.621 191.189H314.068C313.102 191.189 312.318 190.405 312.318 189.439V170.517C312.318 170.379 312.206 170.267 312.068 170.267H271.423C270.456 170.267 269.673 169.483 269.673 168.517V154.979C269.673 154.631 269.776 154.292 269.97 154.003L313.266 89.5305C313.592 89.0465 314.137 88.7561 314.72 88.7561H332.621ZM312.896 117.063C312.325 117.971 311.673 119.025 311.209 119.835C310.267 121.644 309.185 123.497 307.966 125.394L307.963 125.399L290.659 151.841C290.551 152.007 290.67 152.228 290.868 152.228H312.068C312.206 152.228 312.318 152.116 312.318 151.978V135.873C312.318 133.696 312.365 131.048 312.458 127.934C312.551 124.823 312.645 121.947 312.738 119.307V119.295L312.739 119.282C312.795 118.458 312.848 117.718 312.896 117.063Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.106 168.169C342.838 177.572 343.179 189.027 343.053 191.577C341.381 192.513 340.453 192.249 340.453 192.249C340.453 192.249 340.832 184.598 339.727 175.82C338.617 167.001 335.47 156.821 333.001 150.652C332.401 149.287 332.099 148.594 332.328 149.031C332.545 149.533 332.77 150.075 333.001 150.652C334.718 154.554 338.88 163.95 340.106 168.169Z",
    fill: "#73DC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44 167.745C342.949 177.342 340.385 187.981 339.599 190.278C337.579 190.549 336.658 189.979 336.658 189.979C336.658 189.979 339.016 183.087 340.082 174.637C341.152 166.149 340.402 155.692 339.348 149.158C339.057 147.693 338.913 146.951 339.045 147.433C339.148 147.97 339.249 148.547 339.348 149.158C340.179 153.346 342.212 163.44 342.44 167.745Z",
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.548 168.66C340.224 177.54 341.35 188.425 341.374 190.853C339.559 191.781 338.501 191.551 338.501 191.551C338.501 191.551 338.429 184.267 336.62 175.944C334.802 167.584 330.612 157.975 327.442 152.164C326.679 150.88 326.297 150.228 326.582 150.638C326.858 151.111 327.145 151.621 327.442 152.164C329.62 155.836 334.899 164.677 336.548 168.66Z",
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 167.37C342.675 177.032 341.886 188.423 341.915 190.933C343.575 191.648 344.527 191.269 344.527 191.269C344.527 191.269 344.439 183.737 345.899 174.901C347.367 166.024 350.952 155.54 353.696 149.116C354.358 147.688 354.69 146.963 354.441 147.425C354.202 147.95 353.953 148.515 353.696 149.116C351.804 153.199 347.218 163.035 345.811 167.37Z",
    fill: "#73DC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.818 195.72L324.086 195.705C320.61 195.701 318.016 192.291 319.101 188.989C320.995 183.223 323.797 177.361 329.122 178.017C333.259 178.526 337.346 184.018 340.094 189.224C341.73 192.322 339.321 195.724 335.818 195.72Z",
    fill: "#A3A9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 195.953L344.988 195.94C341.111 195.937 338.339 191.653 340.455 188.405C343.031 184.449 346.755 181.009 353.016 181.468C358.027 181.835 362.985 185.367 366.678 189.115C369.425 191.902 367.21 195.956 363.298 195.953Z",
    fill: "#696F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.101 199.008V157.694H233.019V199.008H228.101Z",
    fill: "#DFE2E7",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.596 112.49C268.193 112.843 272.668 112.695 277.455 108.803C272.398 112.915 269.786 113.594 266.498 113.347C260.609 112.904 267.494 115.141 275.322 114.196C271.366 114.935 270.033 115.27 266.245 114.944C260.931 114.487 261.21 112.79 262.932 112.227C262.923 111.977 263.054 111.691 263.212 111.463C264.474 111.572 267.4 111.197 269.003 108.831C268.868 109.762 267.996 111.727 265.596 112.49Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.423 116.839C267.081 116.651 271.607 117.049 276.176 121.028C272.244 116.226 268.751 116.028 265.399 116.075C259.398 116.159 266.54 114.423 274.407 115.771C270.45 114.841 269.123 114.446 265.259 114.54C259.839 114.671 259.999 116.302 261.703 116.937C261.676 117.174 261.788 117.455 261.931 117.68C263.219 117.649 266.158 118.173 267.611 120.517C267.541 119.624 266.8 117.702 264.423 116.839Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.138 169.148C245.686 171.711 247.344 175.871 252.627 179.054C247.044 175.691 245.521 173.464 244.638 170.287C243.058 164.597 243.288 171.832 246.831 178.877C244.795 175.405 244.027 174.265 243.05 170.59C241.678 165.436 243.369 165.124 244.483 166.553C244.715 166.46 245.029 166.486 245.296 166.557C245.622 167.781 246.966 170.407 249.736 171.113C248.815 171.301 246.67 171.147 245.138 169.148Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.65 169.519C241.728 171.956 242.888 176.349 240.693 181.996C243.878 176.669 242.88 173.315 241.699 170.178C239.586 164.561 243.64 170.691 245.039 178.55C244.572 174.512 244.494 173.129 243.096 169.526C241.135 164.471 239.655 165.175 239.635 166.993C239.403 167.048 239.177 167.249 239.013 167.46C239.479 168.661 239.983 171.603 238.27 173.765C239.087 173.397 240.643 172.048 240.65 169.519Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.958 171.232C218.893 173.626 217.784 177.964 220.181 183.648C217.648 177.643 217.727 174.946 218.884 171.857C220.956 166.328 216.883 172.312 215.6 180.092C215.998 176.087 216.049 174.714 217.421 171.168C219.347 166.194 220.897 166.937 220.957 168.748C221.199 168.809 221.437 169.015 221.612 169.23C221.154 170.412 220.695 173.326 222.518 175.526C221.663 175.136 220.02 173.749 219.958 171.232Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.112 168.889C215.548 171.494 213.9 175.728 208.802 179.001C214.512 176.57 215.679 173.271 216.572 170.04C218.17 164.255 217.839 171.597 214.344 178.773C216.343 175.234 217.094 174.071 218.085 170.335C219.475 165.094 217.864 164.792 216.778 166.25C216.558 166.158 216.257 166.187 216 166.261C215.67 167.507 214.345 170.182 211.688 170.921C212.565 171.104 214.617 170.93 216.112 168.889Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.032 114.487C191.482 115.093 187.014 115.384 181.869 111.98C187.305 115.577 189.97 115.996 193.219 115.428C199.035 114.41 192.403 117.311 184.52 117.138C188.529 117.486 189.889 117.688 193.627 116.992C198.871 116.016 198.426 114.356 196.657 113.963C196.641 113.714 196.483 113.442 196.304 113.231C195.058 113.463 192.109 113.377 190.282 111.18C190.508 112.092 191.569 113.963 194.032 114.487Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.669 118.937C195.006 119.011 190.54 119.85 186.384 124.258C189.826 119.094 193.283 118.554 196.623 118.272C202.604 117.768 195.326 116.74 187.629 118.853C191.476 117.54 192.757 117.017 196.612 116.731C202.019 116.33 202.02 117.969 200.386 118.768C200.436 119.001 200.352 119.291 200.232 119.53C198.947 119.625 196.074 120.435 194.858 122.91C194.839 122.014 195.388 120.029 197.669 118.937Z",
    fill: "#73DC78",
    stroke: "#73DC78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.859 121.99L209.244 165.245C209.225 165.364 209.28 165.483 209.383 165.546L215.688 169.426C215.819 169.507 215.99 169.475 216.084 169.353L217.315 167.743C217.489 167.515 217.853 167.638 217.853 167.925V169.268C217.853 169.434 217.987 169.576 218.149 169.614C219.396 169.903 223.182 171.466 223.182 171.466C223.182 171.466 226.027 172.371 228.308 172.445C228.468 172.45 228.599 172.324 228.607 172.165L229.405 156.611C229.424 156.246 229.955 156.225 230.002 156.588L231.991 172.101C232.014 172.284 232.194 172.403 232.37 172.35C236.297 171.159 250.106 166.342 250.606 165.442C251.251 164.281 243.424 120.929 244.714 120.929C246.003 120.929 252.927 121.341 255.635 121.599C257.655 121.791 260.877 122.447 262.523 122.813C262.7 122.853 262.871 122.728 262.888 122.547L264.245 107.866C264.261 107.692 264.126 107.541 263.951 107.538L229.216 106.994L198.41 108.702C198.391 108.703 198.373 108.706 198.354 108.71C197.843 108.828 197.211 108.713 197.092 110.38C196.967 112.14 197.535 119.702 198.321 123.983C198.353 124.157 198.529 124.263 198.7 124.219C200.674 123.712 203.187 123.748 206.626 122.888C212.024 121.539 213.033 121.901 215.524 121.644C215.722 121.623 215.889 121.794 215.859 121.99Z",
    fill: "#DFE2E7",
    stroke: "#00004B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 122.282L215.805 125.725L208.919 166.055L215.805 169.99L218.264 166.055L217.28 170.974L228.593 172.941L229.576 153.268L232.035 172.941L250.725 166.055L245.807 125.725L242.364 123.758L240.203 107.451H236.54L235.97 119.823H223.674L222.349 107.451L218.687 107.909L218.264 122.282Z",
    fill: "#00004B",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.978 134.88L215.404 127.272L213.599 138.362L219.788 143.133L225.978 134.88Z",
    fill: "#DFE2E7",
    stroke: "#00004B",
    strokeWidth: 1.03079
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M235.648 143.52L247.898 141.199L248.672 149.323L237.711 151.386L235.648 143.52Z",
    fill: "#DFE2E7",
    stroke: "#00004B",
    strokeWidth: 1.03079
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.418 113.86L249.816 120.799H254.442L257.333 121.185L258.972 116.462L252.418 113.86Z",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.12 87.0134C232.149 87.0135 234.571 88.2357 236.245 90.2019C237.927 92.1772 238.877 94.9341 238.877 98.0193C238.877 101.105 237.927 103.861 236.245 105.837C234.571 107.803 232.149 109.025 229.12 109.025C223.112 109.025 219.128 104.172 219.128 98.0193C219.128 91.8663 223.112 87.0134 229.12 87.0134Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.185 85.6362C218.664 85.0796 223.226 85.2702 227.631 87.0722L227.71 87.1048L227.796 87.1134C233.754 87.7297 239.087 88.4262 242.895 89.267C244.805 89.6886 246.293 90.1379 247.277 90.6142C247.771 90.8532 248.099 91.0811 248.291 91.2839C248.475 91.4786 248.497 91.6076 248.49 91.6899C248.466 91.9601 248.177 92.4033 247.211 92.882C246.291 93.338 244.925 93.7368 243.158 94.0142C239.634 94.5677 234.633 94.6172 228.709 93.7625L228.666 93.7568L228.623 93.7559C222.523 93.7559 217.621 92.8247 214.29 91.6097C212.622 91.0009 211.374 90.33 210.569 89.69C209.727 89.0208 209.514 88.5074 209.54 88.2208C209.55 88.1088 209.624 87.9204 209.873 87.6691C210.118 87.4225 210.49 87.1581 210.994 86.8973C212 86.3766 213.444 85.9148 215.185 85.6362Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.174 81.5157C232.481 81.7845 234.465 82.9682 235.829 84.463C237.092 85.8467 237.771 87.4388 237.751 88.7542C237.64 88.7787 237.504 88.8097 237.345 88.8416C236.853 88.9401 236.145 89.0665 235.287 89.1751C233.566 89.3926 231.254 89.5382 228.866 89.26C226.449 88.9786 224.37 88.5471 222.897 88.1855C222.161 88.0048 221.575 87.8409 221.176 87.7236C221.105 87.7026 221.04 87.6823 220.981 87.6644C221.29 86.3464 222.362 84.7672 223.937 83.5176C225.664 82.148 227.9 81.2508 230.174 81.5157Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.593 135.139L225.72 138.362",
    stroke: "#868CA2",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.593 136.686L225.72 139.91",
    stroke: "#868CA2",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.787 139.007L223.914 142.23",
    stroke: "#868CA2",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.001 140.426L240.419 145.197",
    stroke: "#868CA2",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.935 139.007L242.354 143.778",
    stroke: "#868CA2",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.119 117.344L250.09 115.409",
    stroke: "#DFE2E7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.886 118.853L248.857 116.919",
    stroke: "#DFE2E7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.058 101.885C233.642 101.899 232.012 102.94 229.517 103.026C226.886 103.118 224.907 102.202 223.21 101.277",
    stroke: "#00004B",
    strokeLinecap: "round",
    strokeDasharray: "1.2 1.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.047,
    cy: 97.5287,
    r: 0.5,
    transform: "rotate(4.37253 234.047 97.5287)",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 0.967341
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.239,
    cy: 96.7789,
    r: 0.5,
    transform: "rotate(4.37253 224.239 96.7789)",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 0.967341
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.391 100.298L228.148 99.0082C228.114 98.8301 228.245 98.6631 228.426 98.6532L229.116 98.6154C229.328 98.6038 229.484 98.8096 229.417 99.0107L228.97 100.338C228.871 100.631 228.448 100.601 228.391 100.298Z",
    fill: "#696F88"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4630_50580",
    x: -453.5,
    y: -170,
    width: 1382,
    height: 718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4630_50580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4630_50580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4630_50580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 702,
    fill: "white",
    transform: "translate(-445.5 -164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Illustration);
export default __webpack_public_path__ + "static/media/404_illustration.44863625fbdd3275e68574585afd3248.svg";
export { ForwardRef as ReactComponent };